/**
 * Demolition keynotes — the firm's keynote list (Supabase `demo_keynotes`, database/283,
 * api/demo-keynotes.js). AlderCAD demolition plans number their keynote tags from it;
 * Templates → Keynotes edits it. Which items each keynote covers is fixed in code
 * (bim/annotation/demoKeynotes.js); the firm edits the wording, the order (= the number)
 * and whether a keynote is used.
 */
import { DEFAULT_DEMO_KEYNOTES } from '../bim/annotation/demoKeynotes.js'

async function post(payload) {
  const headers = { 'Content-Type': 'application/json' }
  if (typeof window !== 'undefined' && typeof window.__clerkGetToken !== 'function') {
    for (let i = 0; i < 40 && typeof window.__clerkGetToken !== 'function'; i++) {
      await new Promise((r) => setTimeout(r, 250))
    }
  }
  if (typeof window !== 'undefined' && typeof window.__clerkGetToken === 'function') {
    try { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } catch { /* unauthed */ }
  }
  const res = await fetch('/api/demo-keynotes', { method: 'POST', headers, body: JSON.stringify(payload) })
  const data = await res.json().catch(() => ({ error: 'Bad response from /api/demo-keynotes' }))
  if (!res.ok || data.error) throw new Error(data.error || ('Request failed (' + res.status + ')'))
  return data
}

/**
 * The firm list in number order: `{ key, appliesTo, text, active }`. Rules the code knows
 * but the table doesn't yet (a rule added after the seed) follow at the end with their
 * default wording; table rows whose rule the code no longer has are dropped.
 */
export async function listDemoKeynotes() {
  const { rows } = await post({ action: 'list' })
  const known = new Map(DEFAULT_DEMO_KEYNOTES.map((d) => [d.key, d]))
  const out = []
  const seen = new Set()
  for (const r of rows || []) {
    const d = known.get(r.key)
    if (!d) continue
    seen.add(r.key)
    out.push({ key: r.key, appliesTo: r.appliesTo || d.appliesTo, text: r.text || d.text, active: r.active !== false })
  }
  for (const d of DEFAULT_DEMO_KEYNOTES) if (!seen.has(d.key)) out.push({ ...d })
  return out
}

/** change one keynote's wording and/or whether it is used */
export async function saveDemoKeynote(ruleKey, { text, active }, byName) {
  const { row } = await post({ action: 'save', ruleKey, note: text, active, byName })
  return row
}

/** the whole list's order (= the keynote numbers) */
export async function reorderDemoKeynotes(ruleKeys) {
  await post({ action: 'reorder', ruleKeys })
}
